export default "__VITE_ASSET__DwA653Zj__"